import Grid from '@material-ui/core/Grid';
import { FC, memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import Input from '~/ui/components/inputs/Input';
import InputMask from '~/ui/components/inputs/InputMask';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import { useStoreState } from '~/store/hooks';
import { IOption } from '~/types';
import formatClientAddress from '~/utils/dataFormat/formatClientAddress';
import addressAdditionalOption from '../../../constants/addressAdditionalOption';

interface IProps {
  states: IOption[];
}

const VisitAddress: FC<IProps> = ({ states }) => {
  const { addresses } = useStoreState(state => state.clientDetails);

  const {
    control,
    watch,
    formState: { errors },
    register,
  } = useFormContext();

  const address = watch('address');

  const filteredAddresses = useMemo(() => {
    const newAddresses = addresses.reduce((acc, obj) => {
      if (!obj.isArchived) {
        acc.push({ value: obj.id, label: formatClientAddress(obj) });
      }

      return acc;
    }, []);

    newAddresses.unshift(addressAdditionalOption);

    return newAddresses;
  }, [addresses]);

  return (
    <>
      <Grid item sm={9}>
        <Select
          hideSelectedOptions={false}
          name="address"
          options={filteredAddresses}
          control={control}
          errors={errors}
          label="Select Address"
        />
      </Grid>
      {!address && (
        <>
          <Grid item sm={12}>
            <h4>Address</h4>
          </Grid>
          <Grid item sm={3}>
            <Input type="text" register={register} errors={errors} name="city" label="City" />
          </Grid>
          <Grid item sm={3}>
            <Select
              control={control}
              errors={errors}
              name="stateId"
              label="State"
              options={states}
              hideSelectedOptions={false}
              openMenuOnFocus
            />
          </Grid>
          <Grid item sm={3}>
            <InputMask
              control={control}
              errors={errors}
              name="zipCode"
              label="Zip Code"
              alwaysShowMask={false}
              mask="99999"
            />
          </Grid>
          <Grid item sm={9}>
            <Input type="text" register={register} errors={errors} name="line1" label="Address" />
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(VisitAddress);
